var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('notifications',{attrs:{"duration":_vm.duration,"group":_vm.group,"position":_vm.position},scopedSlots:_vm._u([{key:"body",fn:function({ item, close }){return [_c('base-text-style',{attrs:{"mode":[
          'primary',
          'secondary',
          'success',
          'error',
          'danger',
          'info',
        ].includes(item.data.type)
          ? 'dark'
          : 'light'}},[_c('div',{staticClass:"base-notification",class:{
          'base-notification--type-primary': item.data.type === 'primary',
          'base-notification--type-secondary': item.data.type === 'secondary',
          'base-notification--type-success': item.data.type === 'success',
          'base-notification--type-warning': item.data.type === 'warning',
          'base-notification--type-danger': item.data.type === 'danger',
          'base-notification--type-error': item.data.type === 'error',
          'base-notification--type-info': item.data.type === 'info',
        }},[(item.data.icon)?_c('base-icon',{staticClass:"base-notification__icon",attrs:{"icon":item.data.icon || 'warning'}}):_vm._e(),_c('div',{staticClass:"base-notification__content"},[_c('base-text-container',{attrs:{"spacing":"tight"}},[(item.title)?_c('base-subheading',[_vm._v(" "+_vm._s(item.title)+" ")]):_vm._e(),_c('p',[_vm._v(_vm._s(item.text))]),(item.data.actions)?_c('base-stack',{staticClass:"base-notification__actions",attrs:{"distribution":"trailing","spacing":"tight"}},_vm._l((item.data.actions),function(action,index){return _c('base-stack-item',{key:index},[_c('base-button',{attrs:{"mode":[
                      'primary',
                      'secondary',
                      'success',
                      'error',
                      'danger',
                      'info',
                    ].includes(item.data.type)
                      ? 'dark'
                      : 'light',"size":"small"},on:{"click":function($event){return action.onClick(close)}}},[_vm._v(" "+_vm._s(action.name)+" ")])],1)}),1):_vm._e()],1)],1)],1)])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }